export default {
    JwtAuthentication: {
        storageKey: "AlmeKey",
    },
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/jwt-authentication.ts